import { call, put } from 'redux-saga/effects';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import {
  changeStatusAfterUpdate,
  fetchActivityLogsRequest,
  manualJournalPostSuccess,
} from '../actions';
import { ManualJournalPostRequestAction } from '../types';

import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn, turnModalOff } from 'store/app/actions';
import { DataLogStatus } from 'store/app/enums';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { fetchOrganisationsRequest } from 'store/organisation/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { renderMessageWithLink } from 'utils/render-message-with-link';
import { manualJournalPost, ManualJournalPostResponse } from '../api';
import i18n from 'i18next';
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* manualJournalPostSaga(action: ManualJournalPostRequestAction) {
  try {
    let err: ApiError | null;
    const { dataLogId, mappingId, journalPostData } = action.payload;

    const response: ManualJournalPostResponse = yield call(
      manualJournalPost,
      dataLogId,
      mappingId,
      journalPostData
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    let description: any = response.responseMessage.message;
    if (response.data?.manualJournalUrl) {
      description = renderMessageWithLink(
        response.responseMessage.message +
          `<br><br>${i18n.t('common.click')}<link>${i18n.t(
            'signup.click-here'
          ).toLowerCase()}</link> ${i18n.t(
            'common.manual-journal-view-link-suffix'
          )}`,
        response.data?.manualJournalUrl
      );
    }
    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(fetchActivityLogsRequest(dataLogId));
    yield put(changeStatusAfterUpdate(DataLogStatus.SUBMITTED));
    yield put(fetchOrganisationsRequest());
    yield put(manualJournalPostSuccess());
    yield put(turnModalOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(manualJournalPostSuccess());
  }
}
